// extracted by mini-css-extract-plugin
export default {"products":"Products_products__LDW4U","section_header":"Products_section_header__X6Haj","title":"Products_title__fZ-5k","price_content":"Products_price_content__BhpDH"};